import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
// import { i18n } from 'config/i18n';
// import { getLanguageInfo } from 'core/i18n';

import { staticURL } from 'core/url';
import { analytics } from 'core/analytics';
import { Link, ExternalLink } from 'core/routing';
import { inWhitelabel, getWhitelabelConfig } from 'core/whitelabel';

import DocumentHead from 'legacyComponents/documentHead';

import { modalStore } from 'apps/modals/app';
import { Menu } from 'apps/modals/menu';

import { Divisor, Button, Icon, Box } from 'components';
import Search from 'apps/components/header/blocks/search';
import MainNav from 'apps/components/header/blocks/mainNav';
import MobileMainNav from 'apps/components/header/blocks/mobileMainNav';
import HeaderAvatar from 'apps/components/header/blocks/headerAvatar';
import HeaderNotifications from 'apps/components/header/blocks/headerNotifications';
// import YellowBanner from 'apps/components/header/blocks/yellowBanner';

import {
  HeaderStyled,
  HeaderContent,
  LogoStyled,
  ButtonBlock,
  HamburgerButtonBlock,
  LogoWhiteLabel,
  UserNav,
  MobileUserNavWrapper,
  WhiteLabelLogoWrapper,
  LogoDivider,
  Actions,
  ActionItem,
} from './header.styled';

const Header = props => {
  const headerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.pageYOffset > headerRef?.current?.clientHeight);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const {
    actions,
    noNav,
    fullWidth,
    isDark,
    clientStore,
    headerStore,
    notificationCenter,
  } = props;

  if (clientStore.signedInProfile) return null;

  const routeName = clientStore.routerStore.route.name;

  const { hamburgerActive } = headerStore;
  const { signedInProfile } = clientStore;

  // const langDisplay = getLanguageInfo(i18n.language).shorthand;
  // const supportedLanguages = i18n.options.supportedLngs.map(code => ({
  //   code,
  //   ...getLanguageInfo(code),
  // }));

  const whitelabelConfig = getWhitelabelConfig();

  const isLanding = inWhitelabel()
    ? false
    : ['home', 'home.home', 'home.faq', 'home.jobs'].includes(routeName) &&
      !!signedInProfile === false;
  const isManuSignUp = routeName.includes('manufacturing');
  const isDarkAndNotScrolling = isDark && !isSticky;
  const { pendingCount: notifCount } = notificationCenter;

  const headerSearch = (isMobile = false) =>
    !noNav && (
      <Box ml={4}>
        <Search
          searchTerm={headerStore?.searchTerm}
          isMobile={isMobile}
          isLogged={!!signedInProfile}
          isDark={isDark}
          inverted={true}
          variant='outlined'
        />
      </Box>
    );

  const onClickSignIn = () => {
    clientStore?.routerStore?.navigate('home.signIn', {
      next: clientStore?.next(),
    });
  };

  const onClickSignUp = () => {
    clientStore?.routerStore?.navigate('home.signUp', {
      next: clientStore?.next(),
    });
  };

  const onClickSignUpManu = () => {
    clientStore?.routerStore?.navigate('home.signUpManufacturer');
  };

  const onClickPlus = () => {
    if (headerStore?.hamburgerActive) headerStore?.ToggleHamburger(false);
    modalStore.SetModalComponent(Menu);
    analytics.sendEvent('clicked-main-menu');
  };

  const onClickMake = () => {
    clientStore?.routerStore?.navigate('make-part');
    analytics.sendEvent('make-part-click-nav-button');
  };

  // const onClickEnterPlatform = () => {
  //   clientStore.routerStore.navigate('home.contribute.projects');
  // };

  // const onClickHelp = () => {
  //   if (window.Intercom) window.Intercom('show');
  //   headerStore?.HideUserDropdown();
  // };

  // const onClickLanguage = language => {
  //   headerStore.SetLangDropdownVisibility(false);
  //   i18n.changeLanguage(language?.code);
  // };

  // const onClickMobileLang = () => {
  //   if (getLanguageInfo(i18n.language).name === 'English') {
  //     i18n.changeLanguage(i18n.options.supportedLngs[1]);
  //   } else {
  //     i18n.changeLanguage(i18n.options.supportedLngs[0]);
  //   }
  // };

  // const onClickUpgradeAccount = () => {
  //   onClickCloseAllMenus();
  //   analytics.sendEvent('clicked-upgrade-button-dropdown');
  // };

  // const onClickFreeTrialBanner = () => {
  //   analytics.sendEvent('clicked-free-trial-banner');
  // };

  return (
    <HeaderStyled
      ref={headerRef}
      isSticky={isSticky}
      isDark={isDarkAndNotScrolling}
    >
      <DocumentHead notificationCount={notifCount} />
      {/* clientStore.hasBanner && <YellowBanner /> */}
      <HeaderContent isFullWidth={fullWidth}>
        {inWhitelabel() ? (
          <ExternalLink to={MAIN_URL} noBlank>
            {/* TODO: Create a greyscale variation for the logo in whitelabelling ?  */}
            <ButtonBlock borderRight negativeVersion={isDark}>
              <LogoStyled negativeVersion={isDark} />
            </ButtonBlock>
          </ExternalLink>
        ) : (
          <Link name='home'>
            <ButtonBlock borderRight negativeVersion={isDark}>
              <LogoStyled negativeVersion={isDark} />
            </ButtonBlock>
          </Link>
        )}
        {inWhitelabel() && (
          <WhiteLabelLogoWrapper>
            <LogoDivider />
            <Link
              name='home'
              content={{
                whitelabel: whitelabelConfig && whitelabelConfig.id,
              }}
            >
              <LogoWhiteLabel
                condition={!isLanding}
                src={inWhitelabel() ? staticURL(whitelabelConfig.logo) : ''}
              />
            </Link>
          </WhiteLabelLogoWrapper>
        )}

        {!noNav && (
          <>
            {headerSearch(false)}
            <MainNav isDark={isDark} />
          </>
        )}

        {signedInProfile && !noNav ? (
          <>
            <MobileUserNavWrapper>
              <HeaderNotifications
                isMobile
                show={headerStore?.notifCenterVisible}
                isDark={isDarkAndNotScrolling}
                headerStore={headerStore}
                notificationCenter={notificationCenter}
              />
              <HeaderAvatar
                isMobile
                show={headerStore?.userDropdownVisible}
                isDark={isDarkAndNotScrolling}
                headerStore={headerStore}
                clientStore={clientStore}
              />
            </MobileUserNavWrapper>
            <UserNav>
              <Button
                variant='primary'
                outline
                ariaLabel='Get a Quote'
                text='Make a Part'
                onClick={onClickMake}
              />
              <Button
                outline
                variant='tertiary'
                icon='add'
                ariaLabel='Create'
                data-intercom-target='project-add'
                onClick={onClickPlus}
              />
              <HeaderNotifications
                show={headerStore?.notifCenterVisible}
                isDark={isDarkAndNotScrolling}
                headerStore={headerStore}
                notificationCenter={notificationCenter}
              />
              <HeaderAvatar
                show={headerStore?.userDropdownVisible}
                isDark={isDarkAndNotScrolling}
                headerStore={headerStore}
                clientStore={clientStore}
              />
            </UserNav>
          </>
        ) : (
          <>
            {!noNav && (
              <UserNav>
                {isManuSignUp ? (
                  <Button
                    icon='arrow_right'
                    text={<Trans>Sign up as Manufacturer</Trans>}
                    onClick={onClickSignUpManu}
                  />
                ) : (
                  <>
                    <Box mr={7} sx={{ display: 'flex', alignItems: 'center' }}>
                      <Button
                        appearance='plain'
                        text={<Trans>Log in</Trans>}
                        onClick={onClickSignIn}
                      />
                      <Divisor variant='vertical' />
                      <Button
                        appearance='plain'
                        text={<Trans>Sign up</Trans>}
                        onClick={onClickSignUp}
                      />
                    </Box>
                    <Button
                      onClick={onClickMake}
                      size='small'
                      text={<Trans>Get a Quote</Trans>}
                    />
                  </>
                )}
              </UserNav>
            )}
          </>
        )}

        {actions && !hamburgerActive && (
          <Actions>
            {actions.map((action, index) => (
              <ActionItem key={index}>{action}</ActionItem>
            ))}
          </Actions>
        )}

        <HamburgerButtonBlock
          negativeVersion={isDarkAndNotScrolling}
          onClick={headerStore?.ToggleHamburger}
        >
          <Icon
            name={!hamburgerActive ? 'menu' : 'close'}
            size={!hamburgerActive ? 'large' : 'medium'}
          />
        </HamburgerButtonBlock>
        <MobileMainNav
          show={hamburgerActive}
          isLogged={!!signedInProfile}
          mainNav={<MainNav isMobile />}
          search={headerSearch(true)}
          routeName={routeName}
          onClickSignIn={onClickSignIn}
          onClickSignUp={onClickSignUp}
        />
      </HeaderContent>
    </HeaderStyled>
  );
};

Header.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.array,
  noNav: PropTypes.bool,
  clientStore: PropTypes.object,
  headerStore: PropTypes.object,
  notificationCenter: PropTypes.object,
  t: PropTypes.func,
  fullWidth: PropTypes.bool,
  isDark: PropTypes.bool,
};

export default withNamespaces()(
  inject('clientStore', 'headerStore', 'notificationCenter')(observer(Header)),
);
